// @flow
export const HIVE2_UPGRADE_CANCEL = 'hive/install/hive2-upgrade/HIVE2_UPGRADE_CANCEL';
export const HIVE2_UPGRADE_START = 'hive/install/hive2-upgrade/HIVE2_UPGRADE_START';
export const HIVE2_UPGRADE_SET_STATE = 'hive/install/hive2-upgrade/HIVE2_UPGRADE_SET_STATE';
export const HIVE2_UPGRADED_FINISHED = 'hive/install/hive2-upgrade/HIVE2_UPGRADED_FINISHED';
export const HIVE2_UPGRADE_RESET = 'hive/install/hive2-upgrade/HIVE2_UPGRADE_RESET';



// WEBPACK FOOTER //
// ./src/core/state/install-upgrade-thermostat/hive2/constants.js